// removed by extract-text-webpack-plugin
module.exports = {"component":"_3bOx2jkHRRu9u05zpEBeP8","contentMobile":"_347IaFnW868NgbhDg0qW3i","isExpanded":"_1ISovTOSX3Zk4XVWMI2CJF","container":"_1l3hV_uU0TVPO0gF_Rxj9s","sender":"_3hVFl7cpyeRaoXzs-YFk76","name":"_10Qx_Q1bwb43Ac1FN5tWJ","timestamp":"_3kRI21M1izPRS_xCBZeP-W","table":"_37OJJ2TAGu9_8UpX3aBkoP","tbody":"-i_oLHIjrWt46kawM_bwK","tr":"_1liUZGkWPNEamgabTAzKrc","td":"vse7lbc-iEfkVWNVHJ_XK","fieldLabel":"_3wCZim-wg_StcDOfdq9E6J","list":"_2GvtFtv5P30pQWX5y5Itv-","content":"_3LYUk8wZH3bYCLxaVGkFgP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Messages/MessageThreadListItem/MessageThreadListItem.css
// module id = 490
// module chunks = 0